import React from 'react'
import { DeliveryHourEditRow } from './deliveryHourEditRow'
import PropTypes from 'prop-types'

export class DeliveryHourEditRows extends React.Component {

  render() {
    return this.props.row === null
      ? <tr/>
      : <tbody>{
        this.props.row.poolTimes.map((poolTime, index) => {
          return <DeliveryHourEditRow
            key={`editDeliveryHours_${this.props.dayName}${index}`}
            row={this.props.row}
            dayName={this.props.dayName}
            index={index}
            onChange={this.props.onChange}
            supportMultipleHours={this.props.supportMultipleHours}
          />
        })
      }</tbody>
  }
}

DeliveryHourEditRows.propTypes = {
  row: PropTypes.exact({
    poolTimes: PropTypes.arrayOf(
      PropTypes.exact({
        startTime: PropTypes.string.isRequired,
        endTime: PropTypes.string.isRequired
      }).isRequired),
    closed: PropTypes.bool.isRequired
  }),
  dayName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  supportMultipleHours: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/containers/pools/details/deliveryHours/deliveryHourEditRows.js